import { Action, Reducer } from "redux";
import { AppState } from "./appState";
import { resetStateReducer } from "./resetStateActions";
import { FooterTabPositionReducer } from "./footerTabPosition";
import { TerminalSelectionReducer } from "./terminalSelection";
import { logUserInReducer, userPermissionsReducer } from "./logUserIn";
import { saveTerminalMasterStateReducer } from "./terminalMaster";
import {
  saveOveragesFilterFormReducer,
  saveFilterValueReducer,
  saveFilterStatusReducer,
  saveFilterDateDataReducer,
  saveFilterCommodityTypeReducer,
  saveFilterExceptionCodeReducer,
  savePackageOptionMasterReducer,
  saveAllExceptionCodeReducer,
  saveShortageExceptionCodeReducer,
  saveShortageStatusReducer,
  saveMyAssignmentStatusReducer,
  saveDamageStatusReducer,
  saveDamageExceptionCodeReducer,
  saveOnHandDeliveryExceptionCodeReducer,
  saveOnHandDeliveryStatusReducer,
  saveMisdeliveryExceptionCodeReducer,
  saveMisdeliveryStatusReducer,
} from "./overagesFilterFormActions";
import { PopoutNotificationReducer } from "./popoutNotification";
import {
  saveDamagesPageObjectReducer,
  saveDamagesSortObjectReducer,
  saveMyAssignmentPageObjectReducer,
  saveMyAssignmentSortObjectReducer,
  saveOnHandDeliveryPageObjectReducer,
  saveOnHandDeliverySortObjectReducer,
  saveOverageListPageObjectReducer,
  saveOverageListSortObjectReducer,
  saveSearchExceptionPageObjectReducer,
  saveSearchExceptionSortObjectReducer,
  saveShortagesPageObjectReducer,
  saveShortagesSortObjectReducer,
  saveMisdeliveryPageObjectReducer,
  saveMisdeliverySortObjectReducer,
} from "./DataTableAction";
import { isFormValueChangedReducer } from "./isFormValueChanged";
import { saveMyAssignmentsFilterFormReducer } from "./myAssignmentsFilterFormActions";
import { saveDocTypesStateReducer } from "./docTypes";
import { saveShortagesFilterFormReducer } from "./shortagesFilterFormAction";
import { saveDamagesFilterFormReducer } from "./damagesFilterFormAction";
import { saveOnHandDeliveryFilterFormReducer } from "./onHandDeliveryFilterFormAction";
import { saveExceptionSearchFilterFormReducer } from "./exceptionSearchFilterFromAction";
import { saveMisdeliveryFilterFormReducer } from "./misdeliveryFilterFormAction";
/**
 * A list of all app state reducers. These are functions that take actions and your previous app state, and calculate out
 * the next app state. Reducers have to be pure functions. Reducers run in their order in this array (This won't matter all that much).
 */
const reducers: Array<(state: AppState, action: Action) => AppState> = [
  // The reducers below are responsible for state toggles and user location within the app
  FooterTabPositionReducer,
  TerminalSelectionReducer,
  logUserInReducer,
  saveTerminalMasterStateReducer,
  saveOveragesFilterFormReducer,
  saveFilterValueReducer,
  saveFilterStatusReducer,
  saveFilterDateDataReducer,
  saveFilterCommodityTypeReducer,
  saveAllExceptionCodeReducer,
  saveShortageExceptionCodeReducer,
  saveFilterExceptionCodeReducer,
  PopoutNotificationReducer,
  saveOverageListPageObjectReducer,
  saveOverageListSortObjectReducer,
  savePackageOptionMasterReducer,
  isFormValueChangedReducer,
  saveMyAssignmentsFilterFormReducer,
  saveExceptionSearchFilterFormReducer,
  saveMyAssignmentPageObjectReducer,
  saveMyAssignmentSortObjectReducer,
  saveDocTypesStateReducer,
  saveShortagesSortObjectReducer,
  saveShortagesPageObjectReducer,
  saveShortagesFilterFormReducer,
  saveShortageStatusReducer,
  saveMyAssignmentStatusReducer,
  userPermissionsReducer,
  saveDamageStatusReducer,
  saveDamageExceptionCodeReducer,
  saveDamagesFilterFormReducer,
  saveDamagesPageObjectReducer,
  saveDamagesSortObjectReducer,
  saveOnHandDeliverySortObjectReducer,
  saveOnHandDeliveryPageObjectReducer,
  saveOnHandDeliveryFilterFormReducer,
  saveOnHandDeliveryExceptionCodeReducer,
  saveOnHandDeliveryStatusReducer,
  saveSearchExceptionPageObjectReducer,
  saveSearchExceptionSortObjectReducer,
  saveMisdeliveryPageObjectReducer,
  saveMisdeliverySortObjectReducer,
  saveMisdeliveryFilterFormReducer,
  saveMisdeliveryExceptionCodeReducer,
  saveMisdeliveryStatusReducer,
  resetStateReducer,
];

const rootReducer: Reducer<AppState> = (state, action) =>
  reducers.reduce((running, next) => next(running, action), state!);

export default rootReducer;
